import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPositionProductGroups as useGetPositionProductGroupsClient } from './position';
import { getStaleTimeInMinutes } from '@/shared/utils/staleTime.ts';

export function getPositionProductGroupsQueryKey(positionId?: string) {
    return ['positionProductGroups', positionId];
}

export const usePositionProductGroups = (positionId?: string, { fetchOnce = false }: { fetchOnce?: boolean } = {}) => {
    const { getPositionProductGroups } = useGetPositionProductGroupsClient();

    return useSuspenseQuery({
        queryKey: getPositionProductGroupsQueryKey(positionId),
        queryFn: async () => {
            return positionId ? getPositionProductGroups(positionId) : null;
        },
        staleTime: getStaleTimeInMinutes(5),
        ...(fetchOnce && { staleTime: Infinity, cacheTime: Infinity }),
    });
};
